// Client side errors
export const errors = {
  GENERIC: {
    reason: 'Hubo un error al subir los documentos',
    description: 'No tenemos información sobre el error, por favor contacta al chat de soporte en teams.',
  },
  PDF_RENDERING_ERROR: {
    reason: 'Error en la previsualización del documento',
    description: 'No se ha podido previsualizar este documento, reintenta nuevamente.',
  },
};

type ExtendedError = {
  reason?: string;
  description?: string;
  [key: string]: unknown;
};

export type ErrorResult = {
  message?: string;
  extended_errors?: ExtendedError;
};

export function getFirstBackendError(
  data?: Record<string, unknown>,
): ErrorResult | null {
  if (!data || typeof data !== 'object') return null;

  if (
    'message' in data
    && (
      typeof data.message === 'string'
      || (Array.isArray(data.message) && data.message.length && typeof data.message[0] === 'string')
    )
  ) {
    return {
      message: Array.isArray(data.message) ? data.message[0] as string : data.message,
      extended_errors: data.extended_errors as ExtendedError,
    };
  }

  if (Array.isArray(data)) {
    for (let i = 0; i < data.length; i += 1) {
      const result = getFirstBackendError(data[i] as Record<string, unknown>);
      if (result) return result;
    }
  }

  // eslint-disable-next-line no-restricted-syntax
  for (const key of Object.keys(data)) {
    const result = getFirstBackendError(data[key] as Record<string, unknown>);
    if (result) return result;
  }

  return null;
}

export type ContractSigningError = typeof errors;
